import Vue from 'vue';
import VueAMap from 'vue-amap';

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '1afab6802be229959ffd060725d5251c',
  plugin: ['AMap.Autocomplete', 'AMap.DistrictSearch', 'AMap.Geocoder', 'AMap.Geolocation', 'AMap.CitySearch'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
});
